<ag-task (goBackEvent)="goBackEvent.emit($event)" [isUrlMode]="isUrlMode" [selectedFeatureMode]="selectedFeatureMode"
         [sidebarEl]="featureComponentSidebarEl" [urlModeGoBackUrl]="urlModeGoBackUrl" class="custom-page-task"
         id="page-task">
  <ng-template agClassifier="{{FeatureComponentMode.BULK_LICENSE}}">
    <app-user-list-bulk (goBackEvent)="goBackEvent.emit($event)"
                        [featureComponentMode]="FeatureComponentMode.BULK_LICENSE"
                        [selectedRows]="selectedRows" class="task-component-detail full-height-container"/>
  </ng-template>
</ag-task>
